import React, { useMemo } from 'react'
import { Button, Icon, Typography } from 'gu-ui-kit'
import { Link } from 'react-router-dom'
import styles from 'modules/Services/Network/network.module.scss'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { ROUTES } from 'constants/routes'
import PropTypes from 'prop-types'

const InstrumentsButtons = ({ networkType, buttonSize = 's' }) => {
  const pathGen = useGeneratePathI18n()
  const hasMediaPlanner = useMemo(() => ['yd', 'vk-ads'].includes(networkType), [networkType])
  const { t } = useTranslation()

  const { notifications: { audit, recommendation, benchmark } = {} } = useSelector(
    (state) => state['recommendations/audits'],
  )

  return (
    <>
      {networkType === 'vk-ads' && (
        <Button
          align={'left'}
          variant={'ghost'}
          size={buttonSize}
          grey
          fullWidth
          startIcon={<Icon name={'gramophone'} />}
          component={Link}
          to={pathGen(ROUTES.SERVICES_NETWORK_CAMPAIGNS_EDITOR_DEFAULT, {
            networkType,
          })}
        >
          {t('services::account_list.campaigns_editor')}
        </Button>
      )}

      {hasMediaPlanner && (
        <Button
          align={'left'}
          variant={'ghost'}
          size={buttonSize}
          grey
          fullWidth={true}
          component={Link}
          to={pathGen(ROUTES.SERVICES_NETWORK_MEDIA_PLANNER, {
            networkType,
          })}
          startIcon={<Icon name={'task'} />}
        >
          {t('media_planner::link')}
        </Button>
      )}

      {networkType === 'yd' && (
        <>
          <Button
            align={'left'}
            variant={'ghost'}
            grey
            size={buttonSize}
            fullWidth={true}
            component={Link}
            to={pathGen(ROUTES.RECOMMENDATIONS_AUDITS)}
            startIcon={<Icon name={'document'} />}
            endIcon={
              audit > 0 ? (
                <Typography
                  variant={'Body-Forms-Description-10'}
                  color={'Label-Onsurface'}
                  className={styles['audits-counter']}
                >
                  +{audit}
                </Typography>
              ) : null
            }
          >
            {t('services::service.audits_button')}
          </Button>
          <Button
            align={'left'}
            variant={'ghost'}
            grey
            size={buttonSize}
            fullWidth={true}
            component={Link}
            to={pathGen(ROUTES.RECOMMENDATIONS_BENCHMARKS)}
            startIcon={<Icon name={'chart-search'} />}
            endIcon={
              benchmark > 0 ? (
                <Typography
                  variant={'Body-Forms-Description-10'}
                  color={'Label-Onsurface'}
                  className={styles['audits-counter']}
                >
                  +{benchmark}
                </Typography>
              ) : null
            }
          >
            {t('services::service.benchmarks_button')}
          </Button>
          <Button
            align={'left'}
            variant={'ghost'}
            grey
            size={buttonSize}
            fullWidth={true}
            component={Link}
            to={pathGen(ROUTES.RECOMMENDATIONS_CAMPAIGNS)}
            startIcon={<Icon name={'document-settings'} />}
            endIcon={
              recommendation > 0 ? (
                <Typography
                  variant={'Body-Forms-Description-10'}
                  color={'Label-Onsurface'}
                  className={styles['audits-counter']}
                >
                  +{recommendation}
                </Typography>
              ) : null
            }
          >
            {t('services::service.recommendations_button')}
          </Button>
        </>
      )}
    </>
  )
}

export default InstrumentsButtons

InstrumentsButtons.propTypes = {
  networkType: PropTypes.string,
  buttonSize: PropTypes.string,
}
